import { render, staticRenderFns } from "./setting-users.vue?vue&type=template&id=0a1ae566"
import script from "./setting-users.vue?vue&type=script&lang=js"
export * from "./setting-users.vue?vue&type=script&lang=js"
import style0 from "./setting-users.vue?vue&type=style&index=0&id=0a1ae566&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports